<template>
    <div>
        <h1>Locker Combinations</h1>
        
        <!-- Combinations Overview -->
        <div  v-if="!$route.params.id">
            <button @click="showCreate = !showCreate">{{showCreate ?'Hide':'Show'}} Create</button>
            <CombinationCreate v-if="showCreate"></CombinationCreate>
            <CombinationList></CombinationList>
        </div>
        <CombinationDetail v-if="$route.params.id"></CombinationDetail>
    </div>
</template>

<script>
    // Import Helpers
    import {EnsureUserLoggedin} from '../Utilities.js'
    import CombinationCreate from '../components/CombinationCreate'
    import CombinationList from '../components/CombinationList'
    import CombinationDetail from '../components/CombinationDetail'

    // Module Code
    export default {
        beforeRouteEnter: EnsureUserLoggedin,
        components: {CombinationCreate, CombinationList, CombinationDetail},
        props: ['id'],
        data: function() {
            return {
                showCreate: false
            }
        }
    }
</script>